import { OpenApiRemoteMethod, OpenApiRemoteMethodParameter } from 'eurogard-open-api-remote-method';
import { ProxyRemoteMethod } from 'eurogard-remote-method';
import { Inject, Injectable } from '@angular/core';

export type SubmitForm = Record<string, unknown>

@Injectable()
export class SubmitFormAdapter extends ProxyRemoteMethod<unknown, SubmitForm, OpenApiRemoteMethodParameter<void>> {

  constructor(
    @Inject(OpenApiRemoteMethod)
      remoteMethod: OpenApiRemoteMethod<unknown, OpenApiRemoteMethodParameter<void>, SubmitForm>,
  ) {
    super(remoteMethod);
  }

  public transformParameters(value: SubmitForm): OpenApiRemoteMethodParameter<void> {
    return {
      requestBody: value,
    };
  }

}

export function SubmitFormAdapterFactory(
  remoteMethod: OpenApiRemoteMethod,
) {
  return new SubmitFormAdapter(
    remoteMethod,
  );
}
